import React from 'react';
import './styles.scss';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const CustomModal = ({
  isOpen,
  toggle,
  title,
  subtitle,
  buttonText,
  Icon,
  onButtonClick,
  CustomMaterialButtonComp
}) => {

  const closeBtn = (
    <button className="close" onClick={toggle} style={{ position: 'absolute', top: '15px', right: '15px' }}>
      <span className="material-icons">close</span>
    </button>
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-container">
      <ModalHeader toggle={toggle} close={CustomMaterialButtonComp || closeBtn} className="modal-header">
        {Icon && <Icon />}
      </ModalHeader>
      <ModalBody className="modal-body">
        {title}
        <h5>{subtitle}</h5>
      </ModalBody>
      <ModalFooter className="modal-footer">
        <div className="continue-button-container">
          <Button className="modal-btn" onClick={onButtonClick}>{buttonText}</Button>{' '}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default CustomModal;